<router-outlet></router-outlet>
<vex-floating-audio-player></vex-floating-audio-player>
